export default {
  mounted() {
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let panX = 0;
    let panY = 0;
    let scale = 1.0;
    const container = this.el;
    const diagram = container.querySelector('.mermaid');
    const loading = container.querySelector('.mermaid-loading');

    // Wait for mermaid to finish rendering and convert to SVG
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          const svg = diagram.querySelector('svg');
          if (svg) {
            // Center diagram initially
            const containerRect = container.getBoundingClientRect();
            const diagramRect = svg.getBoundingClientRect();
            panX = (containerRect.width - diagramRect.width) / 2;
            panY = (containerRect.height - diagramRect.height) / 2;
            updateTransform();
            observer.disconnect();

            // Hide loading and show diagram
            loading.style.display = 'none';
            diagram.style.opacity = '1';
            diagram.classList.add('loaded');
          }
        }
      });
    });

    observer.observe(diagram, { childList: true, subtree: true });

    const updateTransform = () => {
      diagram.style.transform = `translate3d(${panX}px, ${panY}px, 0) scale(${scale})`;
    };

    container.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      isDragging = true;
      startX = e.clientX - panX;
      startY = e.clientY - panY;
      container.style.cursor = 'grabbing';
    });

    const onMouseMove = (e) => {
      if (!isDragging) return;
      panX = e.clientX - startX;
      panY = e.clientY - startY;
      requestAnimationFrame(updateTransform);
    };

    const endDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      container.style.cursor = 'grab';
    };

    // Zoom with scroll wheel
    container.addEventListener('wheel', (e) => {
      e.preventDefault();
      const rect = container.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

      // Calculate zoom
      const delta = -e.deltaY * 0.001;
      const newScale = Math.max(0.1, Math.min(2.0, scale + delta));

      // Adjust pan to zoom around mouse position
      if (newScale !== scale) {
        const scaleChange = newScale / scale;
        panX = mouseX - (mouseX - panX) * scaleChange;
        panY = mouseY - (mouseY - panY) * scaleChange;
        scale = newScale;
        requestAnimationFrame(updateTransform);
      }
    }, { passive: false });

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('mouseleave', endDrag);

    // Cleanup
    this.destroy = () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', endDrag);
      window.removeEventListener('mouseleave', endDrag);
      observer.disconnect();
    };
  },

  destroyed() {
    this.destroy?.();
  }
} 